export const canUseFeature = (
  company: any,
  feature: string,
): boolean => {
  const options = company?.options;
  if (!options) {
    return false;
  }
  return !!options.find((option) => option.optionTypeLabel === feature)?.value;
};
